import { CashDealSummary, DealSummary, ServicesSummary } from './features/DealSummary';
import ActionCard from './features/ActionCard';
import ActivityStatusItemUI from './components/ActivityStatusItem/ActivityStatusItemUI';
import MenuProductCard from './features/MenuProductCard';
import ButtonCard from './features/ButtonCard';
import Header from './features/Header';
import MonthlyInstallment from './features/MonthlyInstallment';
import InfoIcon from './features/InfoIcon';
import Disclaimer from './features/Disclaimer';
import PrivacyPolicy from './features/PrivacyPolicy';
import VisitorAgreement from './features/VisitorAgreement';
import { LineItemUI, GroupLineItemUI } from './features/DealSummary/LineItemUI';
import * as FormatUtils from './utils/formatUtils';

import CurrencyInputUI from './components/CurrencyInput/CurrencyInputUI';
import TextInputUI from './components/TextInput/TextInputUI';
import TooltipUI from './components/Tooltip/TooltipUI';

// for type definitions:
import RadioButtonGroupUI from './components/RadioButtonGroup/RadioButtonGroupUI';
import LoadingButtonUI from './components/LoadingButton/LoadingButtonUI';
import HowItWorksUI from './features/HowItWorks/HowItWorksUI';

// export types
export { IMenuCardPlan } from './features/MenuProductCard/types';
export { IDisclaimerUIStateProps, IDisclaimerUIDispatchProps, IDisclaimerUIProps } from './features/Disclaimer/DisclaimerUI';
export {
    ActivityStatusItemProps,
    IActivityStatusItemStateProps,
    IActivityStatusItemDispatchProps
} from './components/ActivityStatusItem/ActivityStatusItemUI';
export { IVideoOpts } from './features/HowItWorks/HowItWorksUI';
export * from './features/MenuProductCard/MenuProductImage';

// new way to import UIToolkit:
export const UIToolkit = {
    ActionCard,
    ActivityStatusItemUI,
    RadioButtonGroupUI,
    MenuProductCard,
    FormatUtils,
    LineItemUI,
    GroupLineItemUI,
    ButtonCard,
    DealSummary,
    CashDealSummary,
    ServicesSummary,
    Header,
    InfoIcon,
    MonthlyInstallment,
    Disclaimer,
    PrivacyPolicy,
    VisitorAgreement,
    HowItWorksUI,
    LoadingButtonUI,
    TooltipUI,
    CurrencyInputUI,
    TextInputUI
};

// support legacy use for compatibility
export default UIToolkit;
